export const CLEARED = 'casino-heroes/triggers/CLEARED'
export const REMOVED = 'casino-heroes/triggers/REMOVED'
export const UPDATED = 'casino-heroes/triggers/UPDATED'
